import { FunctionComponent } from 'preact';

import { getRawAsset, isLiveStream } from '../../../../utils/player/asset';
import { usePlayer } from '../../hooks/PlayerProvider';
import { Typography } from '../Typography/Typography';
import ns from '../../translations';

import { TypographyProps } from '../Typography/Typography';
import { LiveTimeDisplay } from './LiveTimeDisplay';
import { VodTimeDisplay } from './VodTimeDisplay';
import { usePlayerState } from '../../hooks/usePlayerState';
import { useTranslation } from '../../../../utils/useTranslation';
import { useViewportType } from '../../hooks/useViewportType';

export const TimeDisplay: FunctionComponent<{
  color?: TypographyProps['color'];
}> = ({ color }) => {
  const { t } = useTranslation(ns);

  const player = usePlayer();
  const asset = getRawAsset(player);
  const { isMobile } = useViewportType();

  const state = usePlayerState();
  if (state === 'buffering') {
    return (
      <Typography
        variant="label"
        size={isMobile ? 'medium' : 'large'}
        color="white"
        className="vgp-loading-text"
      >
        {t('Loading ...')}
      </Typography>
    );
  }

  if (!asset) {
    return null;
  }

  return isLiveStream(asset) ? (
    <LiveTimeDisplay color={color} />
  ) : (
    <VodTimeDisplay color={color} />
  );
};
